import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import AddPlot from './pages/add-plot';
import Customers from './pages/customers';

// import Home from './pages/home';
import Login from './pages/login';
import Plots from './pages/plots';
import RequiresAuth from './utils/requiresAuth';


const App = () => {

  return (

    <>
      <Router>

          <Route exact path = '/login' component = { Login } />
          {/* <Route exact path = '/' component = {  RequiresAuth( Home ) } /> */}
          <Route exact path = '/' component = { RequiresAuth( Customers ) } />
          <Route exact path = '/plots' component = {  RequiresAuth( Plots ) } />
          <Route exact path = '/add-plots' component = {  RequiresAuth( AddPlot ) } />
          {/* <Route exact path = '/add-plots?edit=true' component = {  RequiresAuth( AddPlot ) } /> */}
          
      </Router>
    </>
  )
}

export default App;
